var _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgPinLink = function SvgPinLink(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.393 12.91c0 .223.093.446.26.614l1.155 1.042A4.722 4.722 0 0 0 11.197 16a4.78 4.78 0 0 0 3.389-1.415 4.777 4.777 0 0 0 1.415-3.388 4.777 4.777 0 0 0-1.415-3.389L13.487 6.71a.876.876 0 0 0-.614-.261.876.876 0 0 0-.615.26.876.876 0 0 0-.26.615c0 .223.093.447.26.614l1.099 1.099c.577.577.894 1.34.894 2.178a3.04 3.04 0 0 1-.894 2.178 3.04 3.04 0 0 1-2.179.894c-.82 0-1.601-.317-2.178-.894l-1.1-1.098a.877.877 0 0 0-.614-.26.877.877 0 0 0-.614.26.796.796 0 0 0-.28.614Z",
    fill: "currentColor"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.254 6.129c0 .223.093.447.26.614L9.22 10.43c.354.353.894.353 1.23 0a.854.854 0 0 0 0-1.21L6.743 5.532a.876.876 0 0 0-.615-.26.876.876 0 0 0-.614.26 1.02 1.02 0 0 0-.261.596Z",
    fill: "currentColor"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.063 3.724c.168.167.391.26.615.26a.877.877 0 0 0 .614-.26.854.854 0 0 0 0-1.21L8.193 1.414A4.704 4.704 0 0 0 4.804 0a4.761 4.761 0 0 0-3.389 1.396A4.778 4.778 0 0 0 0 4.785C0 6.05.503 7.26 1.415 8.173l1.099 1.099c.354.353.894.353 1.229 0a.876.876 0 0 0 .26-.615.876.876 0 0 0-.26-.614L2.644 6.944a3.038 3.038 0 0 1-.893-2.178c0-.838.316-1.601.893-2.178a3.04 3.04 0 0 1 2.18-.894c.818 0 1.6.317 2.178.894l1.061 1.136Z",
    fill: "currentColor"
  })));
};
export default SvgPinLink;